import { render, staticRenderFns } from "./Proyectos.vue?vue&type=template&id=44dba58c&scoped=true"
import script from "./Proyectos.vue?vue&type=script&lang=js"
export * from "./Proyectos.vue?vue&type=script&lang=js"
import style0 from "./Proyectos.vue?vue&type=style&index=0&id=44dba58c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dba58c",
  null
  
)

export default component.exports